<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">AI Chat Admin</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newPreload()">New Preload</a>
					<a href="#" @click="newContext()">New Context Hint</a>
					<a href="#" @click="onLoad()" v-if="merchant">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-row>
			<b-col></b-col>
			<b-col class="col-md-10">
				<b-row>
					<b-col>
						<h4>Pre Load Instructions</h4>
						<b-table striped hover small :items="preloads" :fields="['from', 'instruction']" selectable select-mode="single" @row-clicked="selectPreload"></b-table>
						<b-row v-if="preload">
							<div class="col-md-2">
								From: <b-form-input class="mb-2" v-model="preload.from"></b-form-input>
							</div>
							<div class="col-md-10">
								Instruction: <b-form-input class="mb-2" v-model="preload.instruction"></b-form-input>
							</div>
							<b-row>
								<b-col class="col-md-1">
									<b-button variant="success" @click="savePreload">Save</b-button>
								</b-col>
								<b-col class="col-md-1">
									<b-button variant="danger" @click="deletePreload">Delete</b-button>
								</b-col>
							</b-row>
						</b-row>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col>
						<h4>Context Hints</h4> 
						<b-table striped hover small :items="contexts" :fields="['keyWords', 'cta', 'appScreen', 'cmsPage', 'externalUrl']" selectable select-mode="single" @row-clicked="selectContext"></b-table>
						<b-row v-if="context">
							<div class="col-md-3">
								Key Words: <b-form-input class="mb-2" v-model="context.keyWords"></b-form-input>
							</div>
							<div class="col-md-6">
								CTA: <b-form-input class="mb-2" v-model="context.cta"></b-form-input>
							</div>
							<div class="col-md-3">
								Screen: <b-form-input class="mb-2" v-model="context.appScreen"></b-form-input>
							</div>
							<b-row>
								<b-col class="col-md-1">
									<b-button variant="success" @click="saveContext">Save</b-button>
								</b-col>
								<b-col class="col-md-1">
									<b-button variant="danger" @click="deleteContext">Delete</b-button>
								</b-col>
							</b-row>
						</b-row>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col>
						<h4>Test Chat MG</h4>
						Provider: <b-form-input class="mb-2" v-model="message.providerOverride"></b-form-input>
						<b-form-textarea disabled name="message" id="message"
							data-lpignore="true" autocomplete="false" style="background-color: #333333; color: white; height: 400px; font-family: courier"
							v-model="chatResponse">
						</b-form-textarea>
						
						<b-input-group class="mt-3">
							<b-form-textarea name="message" id="message"
								data-lpignore="true" autocomplete="false" style="height: 80px;"
								v-model="message.body">
							</b-form-textarea>
							<template #append>
								<b-button style="height: 40px !important;" :disabled="message.body == '' || loading" @click="sendMessage" variant="success"><b-icon icon="play-fill"></b-icon></b-button>
							</template>
						</b-input-group>
					</b-col>
				</b-row>
			</b-col>
			<b-col></b-col>
			

		</b-row>

	</div>
</div>
</template>
<script>
export default {
  name: 'Merchants',
  data() {
	return{
		preloads: null,
		contexts: null,
		preload: null,
		context: null,
		message : { body: "", providerOverride: "OpenAI" },
		self:null,
		chatResponse:null,
		loading:false
	}
  },
  methods: {
	getSelf: function() {
		this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000")
			.then((result) => {
				this.self = result.data;
			}
		)
	},
	sendMessage: function() {
		if (this.message.body == "" || this.message.body == null) { return; }
		this.message.customerId = this.self.id;
		this.loading = true;
		this.chatResponse = "Please wait . . .";
		this.$http.post(this.$config.ApiUri + "/Chats/ChatRequests?customerId=" + this.self.id, this.message)
			.then((result) => {
				this.chatResponse = result.data.body;
				//this.message.body = "";
				this.loading = false;
			}
		)
	},
	newPreload: function() {
		this.preload = {id: null, from: "System", instruction: ""};
	},
	newContext: function() {
		this.context = {id: null, keyWords: "", cta: "", appScreen: ""};
	},
	list: function(){
		this.getPreLoadInstructions();
		this.getContextAppActions();
	},
	saveContext: function() {
		if (this.context.id != null) {
			this.$http.put(this.$config.ApiUri + "/Chats/ContextAppActions/" + this.context.id, this.context)
				.then((result) => {
					this.context = result.data;
					this.list();
				}
			)
		} else {
			this.$http.post(this.$config.ApiUri + "/Chats/ContextAppActions/", this.context)
				.then((result) => {
					this.context = result.data;
					this.list();
				}
			)
		}
	},
	deleteContext: function() {
		this.$http.delete(this.$config.ApiUri + "/Chats/ContextAppActions/" + this.context.id)
			.then(() => {
				this.list();
				this.preload = null;
			}
		)
	},
	savePreload: function() {
		if (this.preload.id != null) {
			this.$http.put(this.$config.ApiUri + "/Chats/PreLoadInstructions/" + this.preload.id, this.preload)
				.then((result) => {
					this.preload = result.data;
					this.list();
				}
			)
		} else {
			this.$http.post(this.$config.ApiUri + "/Chats/PreLoadInstructions/", this.preload)
				.then((result) => {
					this.preload = result.data;
					this.list();
				}
			)
		}
	},
	deletePreload: function() {
		this.$http.delete(this.$config.ApiUri + "/Chats/PreLoadInstructions/" + this.preload.id)
			.then(() => {
				this.list();
				this.preload = null;
			}
		)
	},
	selectContext: function(sel){
		this.context = sel;
	},
	selectPreload: function(sel){
		this.preload = sel;	
	},
	onLoad() {
		this.getSelf();
		this.list();
	},
	getContextAppActions(){
		this.$http.get(this.$config.ApiUri + "/Chats/ContextAppActions")
			.then((result) => {
				this.contexts = result.data;
			}
		)
	},
	getPreLoadInstructions(){
		this.$http.get(this.$config.ApiUri + "/Chats/PreLoadInstructions")
			.then((result) => {
				this.preloads = result.data;
			}
		)
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped="true">
	.child-cat {
		margin:3px;
		background-color: rgb(104, 84, 150);
	}
	.parent-cat {
		margin:3px;
		background-color: rgb(53, 43, 77);
	}

</style>